const {
  getTimeDifference,
  getDateRange,
  toISO,
  ISOToDisplayFormat,
  getCurrentTimeByTimeZone,
  convertToTimeZone,
} = require("@heartinz/date_and_time_processor");

export const getFormattedDate = (isoDate) => {
  const formattedDate = ISOToDisplayFormat(isoDate);
  return formattedDate.date;
};

export const getCurrentDate = (timeZone) => {
  const currentDate = getCurrentTimeByTimeZone(timeZone);
  return currentDate;
};

export const getTimeDiffer = (currentDate, orderDate) => {
  const { days } = getTimeDifference(currentDate, orderDate);
  return days;
};

export const getRangeDates = (rangeType, currentDate) => {
  return getDateRange(rangeType, currentDate);
};

// all date,time
export const getDateFormatted = (isoDate) => {
  const formattedDate = ISOToDisplayFormat(isoDate);
  return formattedDate;
};

export const getconvertToTimeZone = (isoTime, targetTimeZone) => {
  return convertToTimeZone(isoTime, targetTimeZone);
};

// Convert Unix timestamp to ISO format
export const getUnixToIso = (unixTimestamp, timeZone) => {
  const isoDate = toISO(unixTimestamp, "unixEpoch", timeZone);
  return isoDate;
};

export const getToIso = (dateStr, type, timeZone) => {
  const isoDate = toISO(dateStr, type, timeZone);
  return isoDate;
};
